import Reveal from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Which ADAC schema versions do you support?",
    a: "WebADAC validates against current ADAC schema versions and can be configured to your specific acceptance profile. During your demo we'll confirm the exact versions your projects require.",
  },
  {
    q: "Do Councils and Consultants use the same validation rules?",
    a: "Yes — that's the point. We give Consultants exactly what Councils use to validate, and vice versa. Both sides work against the same standard, so there are no surprises at handover.",
  },
  {
    q: "Can I compare a resubmission against the original?",
    a: "Absolutely. The comparison feature diffs two ADAC files and highlights every changed node, so reviewers can focus only on what actually changed.",
  },
  {
    q: "How is this different from a generic XML editor?",
    a: "Generic editors don't understand ADAC. WebADAC enforces the schema, mandatory fields, and your acceptance rules, then profiles data quality and produces audit-ready reports — all in one workflow.",
  },
  {
    q: "Do you store our data securely?",
    a: "Data handling, retention, and access controls are covered during onboarding. We design for audit-ready, defensible workflows and can align with your organization's requirements.",
  },
  {
    q: "How do we get started?",
    a: "Book a demo and we'll walk through your current ADAC workflow, show the platform against a real file, and map out the fastest path to value for your team.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" id="faq" className="py-24 md:py-32 bg-white border-y border-zinc-200">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Reveal className="mb-12 text-center">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">FAQ</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight text-zinc-900 leading-tight">
            Questions, answered.
          </h2>
        </Reveal>

        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-heading font-medium text-zinc-900 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-zinc-600 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
